import React from "react";
import PaymentPolicy from "../components/PaymentPolicy";

const TermsAndConditions = () => {
  return (
    <div className="font-josefin-sans  container mx-auto py-8 mt-20 mb-20">
      <h1 className="text-3xl font-bold mb-6 text-center">
        Terms and Conditions
      </h1>
      <div className="max-w-2xl mx-auto mb-8">
        <p className="mb-4">
          These Terms and Conditions ("Terms") govern your use of the Fynii
          online platform ("Platform"), provided by Fynii Inc. ("Fynii," "we,"
          or "us"). By accessing or using the Platform, you agree to be bound by
          these Terms. If you do not agree with these Terms, you should not use
          the Platform.
        </p>

        <h1 className="font-bold text-2xl mb-6 mt-6">Use of the Platform</h1>
        <p>
          Account Creation: You may need to create an account to access certain
          features of the Platform. You are responsible for maintaining the
          confidentiality of your account credentials and for all activities
          that occur under your account.
        </p>
        <p>
          Prohibited Activities: You agree not to engage in any of the following
          activities while using the Platform.
        </p>
        <br />
        <span className="font-bold">
          Violating any applicable laws or regulations.
        </span>
        <p>Infringing upon the intellectual property rights of others</p>
        <p>
          Uploading or transmitting any harmful, offensive, or inappropriate
          content.
        </p>
        <p>
          Interfering with or disrupting the Platform or its associated
          networks.
        </p>
        <p>Engaging in any fraudulent or misleading activities</p>
        <br />
        <p>
          <span className="font-bold">Content Ownership:</span>Fynii does not
          claim ownership of any content you submit or upload to the Platform.
          However, by using the Platform, you grant Fynii a worldwide,
          non-exclusive, royalty-free license to use, reproduce, modify, adapt,
          publish, distribute, and display your content for the purpose of
          operating and improving the Platform.
        </p>
        <br />
        <p>
          {" "}
          <span className="font-bold">Termination: </span>: Fynii reserves the
          right to suspend or terminate your access to the Platform at any time,
          without notice, for any reason, including but not limited to a
          violation of these Terms.
        </p>
        <div>
          <h1 className="font-bold text-2xl mb-6 mt-6">Community Guidelines</h1>
          <p>
            <span className="font-bold">Respectful Conduct:</span> You are
            expected to treat other users with respect and refrain from engaging
            in abusive, offensive, or harassing behavior on the Platform.
          </p>
          <br />
          <p>
            <span className="font-bold">User Content:</span>
            You are solely responsible for any content you post, upload, or
            transmit on the Platform. You agree not to post any content that is
            illegal, defamatory, or violates the rights of others .
          </p>
          <br />
          <p>
            <span className="font-bold"> Moderation:</span>Fynii reserves the
            right to moderate user-generated content and may remove or edit any
            content that violates these Terms or is otherwise objectionable.
          </p>
        </div>
        <div>
          <h1 className="font-bold text-2xl mt-6 mb-6">
            Disclaimer of Warranty and Limitation of Liability
          </h1>
          <p>
            <span className="font-bold">No Warranty:</span>The Platform is
            provided on an "as is" and "as available" basis, without warranties
            of any kind, either express or implied. Fynii disclaims all
            warranties, including but not limited to the implied warranties of
            merchantability, fitness for a particular purpose, and
            non-infringement.
          </p>
          <br />
          <p>
            <span className="font-bold"> Limitation of Liability:</span>
            In no event shall Fynii be liable for any indirect, incidental,
            special, consequential, or punitive damages arising out of or in
            connection with the use of the Platform, whether based on contract,
            tort, strict liability, or any other legal theory, even if advised
            of the possibility of such damages.
          </p>
        </div>
        <div>
          <h1 className="font-bold text-2xl mb-6 mt-6">
            Intellectual Property Rights
          </h1>
          <p>
            <span className="font-bold"> Trademarks:</span>The Fynii name, logo,
            and any other Fynii trademarks or service marks are the property of
            Fynii Inc. You may not use any Fynii trademarks without prior
            written permission.
          </p>
          <br />
          <p>
            <span className="font-bold"> Copyright::</span>The Platform and its
            content, including but not limited to text, graphics, images, and
            software, are protected by copyright laws and other intellectual
            property rights. You may not reproduce, modify, distribute, or
            display any portion of the Platform without prior written permission
            from Fynii
          </p>
        </div>
        <div>
          <h1 className="font-bold text-2xl mb-6 mt-6">Privacy</h1>
          <p>
            Your privacy is important to us. Please refer to our Privacy Policy
            for information on how we collect, use, and disclose your personal
            information
          </p>
          <br />
          <p> Governing Law and Dispute Resolution</p>
          <br />
          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of [Jurisdiction]. Any dispute arising out of or in
            connection with these Terms shall be resolved through arbitration in
            accordance with the rules of [Arbitration Organization].
          </p>
        </div>
        <div>
          <h1 className="font-bold text-2xlmb-6 mt-6">Modifications</h1>
          <p>
            Fynii reserves the right to modify these Terms at any time without
            prior notice. The updated Terms will be posted on the Platform, and
            your continued use of the Platform after the modifications will
            constitute your acceptance of the updated Terms.
          </p>
          <br />
          <p>
            By using the Fynii online platform, you acknowledge that you have
            read, understood, and agreed to these Terms and Conditions
          </p>
        </div>
      </div>
      <PaymentPolicy />
    </div>
  );
};

export default TermsAndConditions;
